module.exports = __webpack_public_path__ + "img/next.a828eda4.svg";